import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Paper,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
    Modal,
    Button,
  } from "@mui/material";
  import moment from "moment";
  import React, { useEffect, useState } from "react";
  import { getRequest, server } from "../../config";
  import dayjs from "dayjs";
  
  const RequestHistory = ({partnerId}) => {
    const [specificDate, setSpecificDate] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [status, setstatus] = useState('upcoming')
    const [totalEarning, settotalEarning] = useState(0)
    const durationOptions = [
      { label: "All Bookings", value: "all" },
      { label: "Today", value: "today" },
      { label: "This Week", value: "week" },
      { label: "This Month", value: "month" },
      { label: "Specific Date", value: "specific" },
    ];
    const [filterType, setFilterType] = useState("all");
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Reset to the first page when rows per page changes
    };
    const handleChangeStatus = (e) => {
      setstatus(e.target.value);
      setPage(0);
    };
    useEffect(() => {
      fetchCustomers();
    }, [
      
      page,
      rowsPerPage,
      status,
      filterType,
      specificDate,
    ]);
    const fetchCustomers = async () => {
      try {
        let dateFilter = "";
        const today = dayjs().startOf("day");
        const weekStart = dayjs().startOf("week");
        const monthStart = dayjs().startOf("month");
        const specific = specificDate ? dayjs(specificDate).startOf("day") : null;
        if (filterType === "today") {
          dateFilter = { requestedAt: { gte: today.toISOString() } };
        } else if (filterType === "week") {
          dateFilter = { requestedAt: { gte: weekStart.toISOString() } };
        } else if (filterType === "month") {
          dateFilter = { requestedAt: { gte: monthStart.toISOString() } };
        } else if (filterType === "specific" && specific) {
          dateFilter = {
            requestedAt: {
              gte: specific.toISOString(),
              lt: specific.add(1, "day").toISOString(),
            },
          };
        }
        if (Object.keys(dateFilter).length > 0) {
          dateFilter = JSON.stringify(dateFilter);
          dateFilter = dateFilter.slice(1, dateFilter.length - 1);
        }
  
        const filter = {
          skip: page * rowsPerPage,
          limit: rowsPerPage,
        };
  
      
          const response = await getRequest(
            `${server.uri}requestlogs?filter={
          "where":{"partnerId":"${partnerId}",
          "status":"${status}"${
              dateFilter ? "," + dateFilter : ""
            }},
        "skip":"${filter.skip}",
          "limit":"${filter.limit}"
  
          ,"order":"createdAt desc"}`
          );
          //   console.log(response);
       
          setCustomers(response);
          let sum = 0;
          response?.map((item)=>
              sum+= Number(((Number(item?.totalAmount) * 85) / 100).toFixed(2)))
           settotalEarning(sum)
          const responseCount = await getRequest(
            `${server.uri}requestlogs/count?where={
          "partnerId":"${partnerId}",
          "status":"${status}"${
              dateFilter ? "," + dateFilter : ""
            }}`
          );
  
          console.log(responseCount);
  
          setTotalCount(responseCount.count);
      
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    const cities = ["upcoming", "ongoing", "completed"];
    return (
      <Container>
        <Typography variant="h4" sx={{ marginTop: 2, marginBottom: 4 }}>
          RequestHistory
        </Typography>
  
        {/* Search Bar */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          {/* Search Bar */}
          {/* <TextField
          variant="outlined"
          placeholder="Search by Customer name/Mobile Number"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        /> */}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, marginRight: 2 }}
          >
            <TextField
              select
              label="Filter by Duration"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              fullWidth
            >
              {durationOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {/* Specific Date Input (Visible only for "Specific Date" filter) */}
            {filterType === "specific" && (
              <TextField
                type="date"
                label="Select Date"
                InputLabelProps={{ shrink: true }}
                value={specificDate}
                onChange={(e) => setSpecificDate(e.target.value)}
                fullWidth
              />
            )}
             <FormControl
            variant="outlined"
            sx={{ minWidth: 200, marginRight: "10px" }}
          >
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={handleChangeStatus}
              label="City"
              fullWidth
            >
              {/* <MenuItem value="">
                <em>All Cities</em>
              </MenuItem> */}
              {cities.map((city) => (
                <MenuItem key={city} value={city}>
                  {city}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Box>
  
          {/* <FormControl
          variant="outlined"
          sx={{ minWidth: 200, marginRight: "10px" }}
        >
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            onChange={handleChangeStatus}
            label="City"
            fullWidth
          >
           
            {cities.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
          {/* City Dropdown */}
        </Box>
        <Typography sx={{ textAlign: "right" }} variant="subtitle1" gutterBottom>
          Total Bookings: <strong>{totalCount}</strong>
        </Typography>
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f4f6f8", // Light background for table header
                  }}
                >
                  <TableCell sx={{ fontWeight: "bold" }}>Customer Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>SubCategory</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Service Type</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>BookingId</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PinCode</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Booking At</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Earning</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers?.map((customer) => (
                  <TableRow
                    sx={{
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f9fafb", // Alternate row color for better readability
                      },
                    }}
                    key={customer.serviceRequestId}
                  >
                    <TableCell sx={{ cursor: "pointer" }}>
                      {customer?.customerName}
                    </TableCell>
                    <TableCell>{customer?.mobileNumber}</TableCell>
                    <TableCell>{customer?.service?.subCategoryName}</TableCell>
                    <TableCell>{customer?.service?.serviceType}</TableCell>
                    <TableCell>{customer?.service?.categoryName}</TableCell>
                    <TableCell>{customer?.bookingId}</TableCell>
                    <TableCell>{customer?.address}</TableCell>
                    <TableCell>{customer?.pincode}</TableCell>
  
                    <TableCell>
                      {moment(customer?.serviceDate).startOf("hour").fromNow()}
                    </TableCell>
                    <TableCell><strong>₹{  ((Number(customer?.totalAmount) * 85) / 100).toFixed(2)}</strong></TableCell>
                  </TableRow>
                ))}
               
              </TableBody>
            </Table>
           
          </TableContainer>
  
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
           <Typography sx={{ textAlign: "right" ,marginRight:2}} variant="subtitle1" gutterBottom>
          Total Earning: <strong>₹ {totalEarning?.toFixed(2)}</strong>
        </Typography>
        </Paper>
      </Container>
    );
  };
  
  export default RequestHistory;
  